import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useCallback } from "react";
import { Grid, FormControl, makeStyles, Paper, Typography, FormHelperText } from "@material-ui/core";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";
import { TextField } from "@ploy-ui/form-fields";
import { PendingButton } from "@ploy-ui/core";
import { Formik, Form, FastField, connect } from "formik";
import { object, string } from "yup";
const useStyles = makeStyles(theme => ({
    root: {
        whiteSpace: "pre-line",
        padding: theme.spacing(4),
        margin: theme.spacing(2)
    }
}));
const messages = defineMessages({
    invalidLastname: {
        id: "form_fields.lastname.missing",
        defaultMessage: "Surname is missing",
        description: "text for missing lastname"
    },
    invalidFirstname: {
        id: "form_fields.fistname.missing",
        defaultMessage: "First name is missing",
        description: "text for missing firstname"
    }
});
export function AddDriver(props) {
    const { addDriver, loadedData, reloadData } = props;
    const intl = useIntl();
    const classes = useStyles();
    const AddDriverSchema = useMemo(() => object().shape({
        Lastname: string().required(intl.formatMessage(messages.invalidLastname)),
        Firstname: string().required(intl.formatMessage(messages.invalidFirstname))
    }), [intl]);
    const submit = useCallback(async (data, formik) => {
        await onConfirm(data, formik);
        if (reloadData)
            await reloadData({
                applicationId: loadedData?.applicationId
            }, undefined);
        addDriver();
    }, [addDriver, reloadData, loadedData]);
    if (!loadedData)
        return null;
    return (_jsx(Formik, { initialValues: {
            Lastname: "",
            Firstname: "",
            Phone: "",
            Email: "",
            EmployeeNumber: "",
            ApplicationId: loadedData.applicationId
        }, onSubmit: submit, validationSchema: AddDriverSchema, validateOnChange: true, validateOnMount: true, children: ({ isSubmitting, status = {} }) => (_jsx(Form, { children: _jsxs(Paper, { className: classes.root, children: [_jsx(Typography, { variant: "h6", paragraph: true, children: _jsx(FormattedMessage, { id: "dealer.carorderAction.addDriver.header", description: "Car order action add driver header", defaultMessage: "Add driver" }) }), _jsxs(Grid, { container: true, spacing: 2, alignItems: "flex-end", children: [_jsx(Grid, { item: true, xs: 3, children: _jsx(FastField, { name: "Lastname", label: _jsx(FormattedMessage, { id: "dealer.car.order.add.driver.lastname", description: "text for driver lastname", defaultMessage: "Surname" }), component: TextField, margin: "normal", variant: "outlined", helperText: "", disabled: isSubmitting, fullWidth: true }) }), _jsx(Grid, { item: true, xs: 3, children: _jsx(FastField, { name: "Firstname", label: _jsx(FormattedMessage, { id: "dealer.car.order.add.driver.firstname", description: "text for driver firstname", defaultMessage: "First name " }), component: TextField, margin: "normal", variant: "outlined", helperText: "", disabled: isSubmitting, fullWidth: true }) }), _jsx(Grid, { item: true, xs: 3, children: _jsx(FastField, { name: "Phone", label: _jsx(FormattedMessage, { id: "dealer.car.order.add.driver.phone", description: "text for driver phone", defaultMessage: "Telephone " }), component: TextField, margin: "normal", variant: "outlined", helperText: "", disabled: isSubmitting, fullWidth: true }) }), _jsx(Grid, { item: true, xs: 3, children: _jsx(FastField, { name: "Email", label: _jsx(FormattedMessage, { id: "dealer.car.order.add.driver.email", description: "text for driver email", defaultMessage: "Email" }), component: TextField, margin: "normal", variant: "outlined", helperText: "", disabled: isSubmitting, fullWidth: true }) }), _jsx(Grid, { item: true, xs: 3, children: _jsx(FastField, { name: "EmployeeNumber", label: _jsx(FormattedMessage, { id: "dealer.car.order.add.driver.EmployeeNumber", description: "text for driver employee number", defaultMessage: "Employee number" }), component: TextField, margin: "normal", variant: "outlined", helperText: "", disabled: isSubmitting, fullWidth: true }) })] }), _jsxs(Grid, { container: true, spacing: 4, children: [_jsx(Grid, { item: true, children: _jsxs(FormControl, { variant: "standard", margin: "normal", children: [_jsx(SubmitButton, { variant: "contained", size: "large", color: "secondary", children: "Legg til" }), _jsx(FormHelperText, { color: status.success && !status.error ? "inherit" : "error", children: status.error || status.message || " " })] }) }), _jsx(Grid, { item: true, children: _jsxs(FormControl, { variant: "standard", margin: "normal", children: [_jsx(PendingButton, { variant: "contained", onClick: () => addDriver(), size: "large", children: "Avbryt" }), _jsx(FormHelperText, { color: status.success && !status.error ? "inherit" : "error", children: status.error || status.message || " " })] }) })] })] }) })) }));
}
const onConfirm = async (data, formik) => {
    const response = await fetch("/Driver/SaveDriver", {
        method: "POST",
        body: new Blob([JSON.stringify(data)], { type: "application/json" }),
        headers: {
            accept: "application/json"
        }
    });
    if (response.ok) {
        formik.setSubmitting(false);
    }
    else {
        formik.setStatus({ error: "" });
    }
};
const SubmitButton = connect(({ formik, ...props }) => (_jsx(PendingButton, { pending: formik.isSubmitting, disabled: !formik.isValid, onClick: () => {
        formik.submitForm();
    }, ...props })));
//# sourceMappingURL=CarOrderAddDriver.js.map